import * as React from 'react'
import './Block.css'

class Block extends React.Component<{
  left?: React.ReactNode,
  right?: React.ReactNode,
  className?: string,
  attributes?: React.HTMLAttributes<HTMLDivElement>,
}> {

  render() {
    const {left, right, className = "", attributes = {}} = this.props

    return (
      <div className={"Block " + className} {...attributes}>
        <div className="Block-left">
          {left}
        </div>
        <div className="Block-right">
          {right}
        </div>
      </div>
    )
  }
}

export default Block;



// WEBPACK FOOTER //
// ./src/view/Block.tsx